<template>
  <v-card align="center" justify="center" min-width="25vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('delete') }} {{ capitalize(consideration.type) }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p class="text-center" v-html="$t('areYouSureToDelete',{name: consideration.name,type: capitalize(consideration.type)})"></p>
      <p class="text-center py-2">{{ $t('actionCannotBeUndone') }}<v-icon class="ml-1" small>fa-exclamation-triangle</v-icon></p>
      <v-btn @click="deleteConsideration">{{ $t('yesDelete') }} {{ capitalize(consideration.type) }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/consideration';
import { mapMutations } from 'vuex';

export default {
  name: "DeleteConsideration",
  props: {
    consideration: Object,
  },
  methods: {
    ...mapMutations(['setConsiderations']),
    deleteConsideration() {
      Repository.deleteConsideration(this.consideration.id).then((response) => {
        if(response.status < 400) {
          Repository.getConsiderationsByUser(this.$store.state.user.id).then((secondResponse) => {
            if (secondResponse.status < 400) {
              this.setConsiderations(secondResponse.data);
              alert(this.$t('alertMessage_DeleteConsideration',{type: this.capitalize(this.consideration.type)}));
            }
          });
          this.close();
        }
      });
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>

</style>



